import { Injectable } from '@angular/core';
import { AttachDocument } from '../models/attach-document';
import { AttachDocumentService } from '../data-service/attach-document.service';

@Injectable({
  providedIn: 'root'
})
export class DownloadFileHelperService {

  constructor(private attachDocumentService: AttachDocumentService) { }

  async downloadAttachment(attachDocument: AttachDocument, callback: (x: boolean) => void) {
    return this.attachDocumentService.downloadAttachment(attachDocument.internalFileName).
      subscribe(x => {
        const filename = attachDocument.name !== undefined ? attachDocument.name : this.GetFileName(attachDocument.internalFileName);
        this.download(x, filename);
        if (callback) {
          callback(true);
        }
      }, () => {
        if (callback) {
          callback(false);
        }
      });
  }

  download(x: Blob, name: string) {
    const newBlob = new Blob([x], { type: 'application/octet-stream' });
    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(newBlob, name);
      return;
    }
    const data = window.URL.createObjectURL(newBlob);
    const link = document.createElement('a');
    link.href = data;
    link.download = name;
    link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    setTimeout(() => {
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(data);
    }, 100);
  }

  private GetFileName(internalFileName: string): string {
    let fileName = '';
    const pattern = '([a-z0-9]{8}[-][a-z0-9]{4}[-][a-z0-9]{4}[-][a-z0-9]{4}[-][a-z0-9]{12})';
    internalFileName = internalFileName.replace('#/downloadFile', '');
    const arr = internalFileName.split('/');
    const index = arr.length - 1;
    const regex = new RegExp(pattern).exec(arr[index]);
    fileName = regex !== null ? arr[index].substring(regex[0].length + 1) : arr[index];

    return fileName;
  }
}
